import { render, staticRenderFns } from "./BizHisTaskModule.vue?vue&type=template&id=55c44bfc&scoped=true&"
import script from "./BizHisTaskModule.vue?vue&type=script&lang=js&"
export * from "./BizHisTaskModule.vue?vue&type=script&lang=js&"
import style0 from "./BizHisTaskModule.vue?vue&type=style&index=0&id=55c44bfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c44bfc",
  null
  
)

export default component.exports